export const STORAGE_TYPE = Object.freeze({
  CHAT_DRAFT: 'CHAT_DRAFT',
});



// WEBPACK FOOTER //
// ./app/javascript/common/utils/storage/constants.js